import React, { useEffect, useRef, useState } from "react";
import Header from "../../Common/Header/Header";
import axios from "../../../Services/axios";
import Swal from "sweetalert2";
import "./print.css";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import CircularProgress from "@mui/material/CircularProgress";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const image = new Image();
image.src = "https://rmsrms.s3.ap-south-1.amazonaws.com/files/Group 2570.png";

const plugin = {
  id: "customCanvasBackgroundImage",
  beforeDraw: (chart) => {
    if (image.complete) {
      const ctx = chart.ctx;

      ctx.drawImage(
        image,
        chart.chartArea.left,
        chart.chartArea.top,
        chart.chartArea.width,
        chart.chartArea.height
      );
    } else {
      image.onload = () => chart.draw();
    }
  },
};

const labels = [
  "",
  "Al",
  "B",
  "C",
  "Co",
  "Cr",
  "Cu",
  "Fe",
  "Mn",
  "Mo",
  "N",
  "Nb",
  "Ni",
  "O",
  "P",
  "S",
  "Si",
  "Ti",
  "V",
  "W",
  "Zr",
  "",
];

export const data = {
  labels,

  datasets: [
    {
      borderWidth: 1,
      tension: 0.1,
      label: "Standard Deviation from the MEAN",
      data: [
        0, 1.58, -0.83, -0.65, -0.71, -0.92, -0.66, 0.61, 0.14, 0.13, 1.06,
        -1.14, -0.19, 0.25, 0.5, 1.43, -2.75, 0.34, 0.01, 2.94, 0.0, 0,
      ],
      borderColor: "#000",
      backgroundColor: "#000",
    },
  ],
};

const Chart = React.forwardRef((props, ref) => {
  const options = {
    responsive: true,

    scales: {
      y: {
        ticks: {
          stepSize: 1,
        },
        title: {
          font: {
            size: 16,
          },

          display: true,
          text: "Standard Deviations from the MEAN",
        },

        min: -5,
        max: 5,
      },
      x: {
        title: {
          font: {
            size: 16,
          },

          display: true,
          text: "Reported Elements (excluding <values)",
        },
      },
    },

    plugins: {
      legend: {
        display: false,
        position: "top",
      },
      title: {
        display: true,
        text: "Z-Score Summary Chart",
        font: {
          size: 36,
        },
      },
      datalabels: {
        display: function (context) {
          if (
            context.dataset.data[context.dataIndex] > -5 &&
            context.dataset.data[context.dataIndex] < 5
          ) {
            return context.dataset.data[context.dataIndex];
          } else {
            return "";
          }
        },
        color: "black",
        align: "end",
        padding: {
          right: 4,
        },
        labels: {
          padding: { top: 20 },
          title: {
            font: {
              weight: "bold",
            },
          },
          value: {
            color: "black",
          },
        },
      },
    },
  };

  const [rmptId, setRmptId] = useState("");
  const [date, setDate] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [labels, setlabels] = useState([]);
  const [grade, setGrade] = useState("");
  const [rmrm, setRmrm] = useState("");
  const [series, setSeries] = useState("");
  const [uns, setUns] = useState("");
  const [data, setData] = useState([]);

  function formatDate(inputDate) {
    const date = new Date(inputDate);
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();
    const formattedDate = months[month] + " " + day + ", " + year;
    return formattedDate;
  }
  useEffect(() => {
    const userId = localStorage.getItem("UserId");
    const referenceId = localStorage.getItem("referenceId");
    const analystId = localStorage.getItem("analystId");

    axios
      .get(
        `/rmpt/getChartData?id=${userId}&reference_id=${referenceId}&analyst_id=${analystId}`
      )
      .then((response) => {
        let res = JSON.parse(response.data);
        if (res.status === 200) {
          setRmptId(res.data.rmptId);
          setDate(res.data.date);
          setSeries(res.data.series);
          setGrade(res.data.grade);
          setRmrm(res.data.rmrm);
          setUns(res.data.uns);
          setCompanyName(res.data.userData.basic_details.company_name);
          const chartLabel = [];
          chartLabel.push("");
          const chartData = [];
          chartData.push(0);
          res.data.chartData.forEach((e) => {
            if (e.zscore !== "" || e.cert !== 0) {
              chartLabel.push(e.analyte);
              chartData.push(e.zscore);
            }
          });
          chartLabel.push("");
          chartData.push(0);
          setlabels(chartLabel);
          setData(chartData);
        } else {
          Swal.fire({
            position: "center",
            icon: "error",
            title: res.message,
            showConfirmButton: true,
            // timer: 1500,
          });
        }
      })
      .catch((error) => {})
      .then(() => {});
    window.scrollTo(0, 0);
    // eslint-disable-next-line
  }, []);

  return (
    <div ref={ref} className="">
      <div className="chart">
        <div className="chart__head">
          <div className="chart__head--text">{companyName}</div>
          <div className="chart__head--text">{formatDate(date)}</div>
        </div>
        <div className="chart__desc">
          {grade} / <span>UNS {uns}</span> - RMPT#{" "}
          <span className="highlight">{rmptId}</span> - CRM#{" "}
          <span>
            {rmrm}
            {series}
          </span>
        </div>
      </div>{" "}
      <Line
        plugins={[plugin]}
        options={options}
        data={{
          labels: labels,

          datasets: [
            {
              borderWidth: 1,
              lineTension: 0,

              // tension: 0.1,
              label: "Standard Deviation from the MEAN",
              data: data,
              borderColor: "#000",
              backgroundColor: "#000",
            },
          ],
        }}
      />
      <div className="chart__footer">
        Z-Score, Calculated by Comparing User Submitted Data with the Value
        Assignment of the CRM used.
      </div>
    </div>
  );
});

const AmendedChart = React.forwardRef((props, ref) => {
  const options = {
    responsive: true,

    scales: {
      y: {
        ticks: {
          stepSize: 1,
        },
        title: {
          font: {
            size: 16,
          },

          display: true,
          text: "Standard Deviations from the MEAN",
        },

        min: -5,
        max: 5,
      },
      x: {
        title: {
          font: {
            size: 16,
          },

          display: true,
          text: "Reported Elements (excluding <values)",
        },
      },
    },

    plugins: {
      legend: {
        display: false,
        position: "top",
      },
      title: {
        display: true,
        text: "Amended Z-Score Summary Chart",
        font: {
          size: 36,
        },
      },
      datalabels: {
        display: function (context) {
          if (
            context.dataset.data[context.dataIndex] > -5 &&
            context.dataset.data[context.dataIndex] < 5
          ) {
            return context.dataset.data[context.dataIndex];
          } else {
            return "";
          }
        },
        color: "black",
        align: "end",
        padding: {
          right: 4,
        },
        labels: {
          padding: { top: 20 },
          title: {
            font: {
              weight: "bold",
            },
          },
          value: {
            color: "black",
          },
        },
      },
    },
  };
  const [rmptId, setRmptId] = useState("");
  const [date, setDate] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [labels, setlabels] = useState([]);
  const [grade, setGrade] = useState("");
  const [rmrm, setRmrm] = useState("");
  const [series, setSeries] = useState("");
  const [uns, setUns] = useState("");
  const [data, setData] = useState([]);
  const formatDate = (created) => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const date = new Date(created);
    return (
      monthNames[date.getMonth()] +
      " " +
      date.getDay() +
      "," +
      date.getFullYear()
    );
  };
  useEffect(() => {
    const userId = localStorage.getItem("UserId");
    const referenceId = localStorage.getItem("referenceId");
    const analystId = localStorage.getItem("analystId");
    const reappeal = localStorage.getItem("reappealed");
    if (!reappeal || reappeal === "no") {
      return;
    }
    axios
      .get(
        `/rmpt/getAmendedChartData?id=${userId}&reference_id=${referenceId}&analyst_id=${analystId}`
      )
      .then((response) => {
        let res = JSON.parse(response.data);
        if (res.status === 200) {
          setRmptId(res.data.rmptId);
          setDate(res.data.date);
          setSeries(res.data.series);
          setGrade(res.data.grade);
          setRmrm(res.data.rmrm);
          setUns(res.data.uns);
          setCompanyName(res.data.userData.basic_details.company_name);
          const chartLabel = [];
          chartLabel.push("");
          const chartData = [];
          chartData.push(0);
          res.data.chartData.forEach((e) => {
            if (e.zscore !== "" || e.cert !== 0) {
              chartLabel.push(e.analyte);
              chartData.push(e.zscore);
            }
          });
          chartLabel.push("");
          chartData.push(0);
          setlabels(chartLabel);
          setData(chartData);
        } else {
          Swal.fire({
            position: "center",
            icon: "error",
            title: res.message,
            showConfirmButton: true,
            // timer: 1500,
          });
        }
      })
      .catch((error) => {})
      .then(() => {});
    window.scrollTo(0, 0);
    // eslint-disable-next-line
  }, []);

  return (
    <div ref={ref} className="">
      <div className="chart">
        <div className="chart__head">
          <div className="chart__head--text">{companyName}</div>
          <div className="chart__head--text">{formatDate(date)}</div>
        </div>
        <div className="chart__desc">
          {grade} / <span>UNS {uns}</span> - RMPT#{" "}
          <span className="highlight">
            {rmptId}{" "}
            {localStorage.getItem("type") &&
            localStorage.getItem("type") === "reappeal"
              ? "-1"
              : ""}
            {localStorage.getItem("type") &&
            localStorage.getItem("type") === "finalreport"
              ? "-1"
              : ""}
          </span>{" "}
          - CRM#{" "}
          <span>
            {rmrm}
            {series}
          </span>
        </div>
      </div>

      <Line
        plugins={[plugin]}
        options={options}
        data={{
          labels: labels,

          datasets: [
            {
              borderWidth: 1,
              // tension: 0.1,
              lineTension: 0,

              label: "Standard Deviation from the MEAN",
              data: data,
              borderColor: "#000",
              backgroundColor: "#000",
            },
          ],
        }}
      />
      <div className="chart__footer">
        Z-Score, Calculated by Comparing User Submitted Data with the Value
        Assignment of the CRM used.
      </div>
    </div>
  );
});

const SampleClosedChart = () => {
  const componentRef = useRef();
  const amendedComponentRef = useRef();
  const [data, setData] = useState([]);
  const [rmptId, setRmptId] = useState([]);
  const [loader, setLoader] = useState(false);

  const [firstName, setFirstName] = useState("");
  const [email, setEmail] = useState("");
  const [telephone, setTelephone] = useState("");
  const [address, setAddress] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [fax, setFax] = useState("");
  const [zip, setZip] = useState("");
  const [analyst, setAnalyst] = useState("");
  const [date, setDate] = useState("");
  const [amendedAnalyst, setAmendedAnalyst] = useState("");
  const [amendedDate, setAmendedDate] = useState("");

  function formatDate(inputDate) {
    const date = new Date(inputDate);
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();
    const formattedDate = months[month] + " " + day + ", " + year;
    return formattedDate;
  }
  const [amendedData, setAmendedData] = useState([]);
  useEffect(() => {
    const userId = localStorage.getItem("UserId");
    const referenceId = localStorage.getItem("referenceId");
    const analystId = localStorage.getItem("analystId");

    axios
      .get(
        `/rmpt/getZScoreSummaryData?id=${userId}&reference_id=${referenceId}&analyst_id=${analystId}`
      )
      .then((response) => {
        let res = JSON.parse(response.data);
        if (res.status === 200) {
          setData(res.data.chartData);
          setRmptId(res.data.rmptId);
          setAnalyst(res.data.analyst);
          setDate(res.data.date);
          setFirstName(res.data.userData.basic_details.first_name);
          setEmail(res.data.userData.basic_details.email);
          setTelephone(res.data.userData.basic_details.telephone);
          setAddress(res.data.userData.basic_details.address);
          setState(res.data.userData.basic_details.state);

          setCity(res.data.userData.basic_details.city);
          setFax(res.data.userData.basic_details.fax);
          setZip(res.data.userData.basic_details.zip);
        } else {
          Swal.fire({
            position: "center",
            icon: "error",
            title: res.message,
            showConfirmButton: true,
            // timer: 1500,
          });
        }
      })
      .catch((error) => {})
      .then(() => {});
    window.scrollTo(0, 0);
    // eslint-disable-next-line
  }, []);
  const [isPrinting, setIsPrinting] = useState(false);

  useEffect(() => {
    const handleBeforePrint = () => {
      const mainPortal = document.querySelector(".mainPortal");

      mainPortal.style.paddingTop = "20px";

      setIsPrinting(true);
    };

    const handleAfterPrint = () => {
      const mainPortal = document.querySelector(".mainPortal");

      mainPortal.style.paddingTop = "80px";

      setIsPrinting(false);
    };

    window.addEventListener("beforeprint", handleBeforePrint);
    window.addEventListener("afterprint", handleAfterPrint);

    return () => {
      window.removeEventListener("beforeprint", handleBeforePrint);
      window.removeEventListener("afterprint", handleAfterPrint);
    };
  }, []);

  useEffect(() => {
    const userId = localStorage.getItem("UserId");
    const referenceId = localStorage.getItem("referenceId");
    const analystId = localStorage.getItem("analystId");
    const reappeal = localStorage.getItem("reappealed");
    if (!reappeal || reappeal === "no") {
      return;
    }
    axios
      .get(
        `/rmpt/getAmendedZScoreSummaryData?id=${userId}&reference_id=${referenceId}&analyst_id=${analystId}`
      )

      .then((response) => {
        let res = JSON.parse(response.data);
        if (res.status === 200) {
          setAmendedData(res.data.chartData);
          setAmendedAnalyst(res.data.analyst);
          setAmendedDate(res.data.date);
        } else {
          Swal.fire({
            position: "center",
            icon: "error",
            title: res.message,
            showConfirmButton: true,
            // timer: 1500,
          });
        }
      })
      .catch((error) => {})
      .then(() => {});

    // eslint-disable-next-line
  }, []);

  const handlePrint = () => {
    setIsPrinting(true);

    setTimeout(() => {
      componentRef.current.classList.add("printable");

      window.print();
      setIsPrinting(false);
      componentRef.current.classList.remove("printable");
    }, 1000); // Adjust the delay as needed
  };

  return (
    <>
      {loader || isPrinting ? (
        <div className="loader">
          <CircularProgress />
        </div>
      ) : null}

      {!isPrinting && (
        <Header themeWhite={true} contactBtn={true} bgLight={true} />
      )}

      <div className="mainSection mainPortal">
        {localStorage.getItem("type") &&
        localStorage.getItem("type") === "finalreport" &&
        localStorage.getItem("type") === "finalreport" &&
        localStorage.getItem("reappealed") === "yes" ? (
          <div id="app" className="app" ref={componentRef}>
            {" "}
            <div class="first-page-wrapper">
              <section className="page__section portrait">
                <div
                  style={{ border: isPrinting ? "none" : "" }}
                  className="form__container"
                >
                  <form className="form form__user">
                    <div className="flex alignitems--center justifyspace--between">
                      <span className="highlightedText"></span>

                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          handlePrint();
                        }}
                        className="btn--print"
                      >
                        <PrintOutlinedIcon />
                        Print this out!
                      </button>
                    </div>
                  </form>
                  <div
                    style={{
                      display: "flex",
                      marginBottom: "15px",
                      justifyContent: "space-around",
                    }}
                  >
                    <div className="alignment" style={{ lineHeight: "10px" }}>
                      <img
                        alt="RMRMs"
                        src="data:image/png;base64,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"
                        style={{
                          display: "block",
                          height: "auto",
                          border: 0,
                          width: "100px",
                          maxWidth: "100%",
                        }}
                        title="RMRMs"
                        width="195"
                      />
                    </div>
                    <div>
                      <h2
                        style={{
                          color: "#000",
                          fontFamily: "'Jost', sans-serif",
                          fontSize: "24px",
                          fontWeight: 500,
                          letterSpacing: "normal",
                          lineHeight: "32px",
                          margin: 0,
                          textAlign: "center",
                        }}
                      >
                        Rocky Mountain Proficiency Testing
                      </h2>
                      <p
                        style={{
                          color: "#000",
                          fontFamily: "'Jost', sans-serif",
                          fontSize: "18px",
                          fontWeight: 400,
                          letterSpacing: "normal",
                          lineHeight: "32px",
                          margin: 0,
                          textAlign: "center",
                        }}
                      >
                        A Division of Rocky Mountain Reference Materials
                      </p>
                    </div>
                    <div className="alignment" style={{ lineHeight: "10px" }}>
                      <img
                        alt="RMRMs"
                        src="data:image/png;base64,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"
                        style={{
                          display: "block",
                          height: "auto",
                          border: 0,
                          width: "100px",
                          maxWidth: "100%",
                        }}
                        title="NVLAP LAB CODE 200111-0"
                        width="177"
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginBottom: "15px",
                    }}
                  >
                    <h2
                      style={{
                        fontFamily: "'Jost', sans-serif",
                        fontSize: "24px",
                        fontWeight: 500,
                        letterSpacing: "normal",
                        lineHeight: "25px",
                        color: "#20292F",
                        margin: "0 0 10px 0",
                        textDecoration: "underline",
                        textAlign: "center",
                      }}
                    >
                      RMPT Z-Score Summary Report Form
                    </h2>
                  </div>

                  <header className="report-header">
                    <div className="header-left">
                      <p>(F): (720) 943-7670</p>
                      <p>RMPT@RMRMs.com</p>
                      <p>Attn: RMPT Processing Dept.</p>
                      <p>October 19, 2018</p>
                      <p style={{ fontWeight: "bold" }}>
                        Results for RMPT#
                        <span className="highlightedText">{rmptId}</span>
                      </p>
                    </div>
                    <div className="header-right">
                      <p>{firstName}</p>
                      <p>{address}</p>
                      <p>
                        {state}, {city} {zip}
                      </p>
                      <p>
                        (P:) {telephone} (F:) {fax}
                      </p>
                      <p>{email}</p>
                    </div>
                  </header>

                  <form className="form form__user">
                    <div
                      style={{
                        minHeight: "100%",
                        width: "100%",
                        overflowY: "auto",
                      }}
                      id="printablediv"
                    >
                      <div className="zscore-container">
                        <div className="zscore-column">
                          <TableContainer className="form__table form__zscore">
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell align="center">Analyte</TableCell>
                                  <TableCell align="center">Data</TableCell>
                                  <TableCell align="center">Cert</TableCell>
                                  <TableCell align="center">Variance</TableCell>
                                  <TableCell align="center">Z-Score</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {data
                                  .slice(0, Math.ceil(data.length / 2))
                                  .map((value, index) => (
                                    <TableRow hover key={index}>
                                      <TableCell align="center">
                                        {value.analyte}
                                      </TableCell>
                                      <TableCell align="center">
                                        {value.data}
                                      </TableCell>
                                      <TableCell align="center">
                                        {value.cert}
                                      </TableCell>
                                      <TableCell align="center">
                                        {value.variance}
                                      </TableCell>
                                      <TableCell align="center">
                                        {value.zscore}
                                      </TableCell>
                                    </TableRow>
                                  ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </div>

                        <div className="zscore-column">
                          <TableContainer className="form__table form__zscore">
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell align="center">Analyte</TableCell>
                                  <TableCell align="center">Data</TableCell>
                                  <TableCell align="center">Cert</TableCell>
                                  <TableCell align="center">Variance</TableCell>
                                  <TableCell align="center">Z-Score</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {data
                                  .slice(
                                    Math.ceil(data.length / 2),
                                    data.length
                                  )
                                  .map((value, index) => (
                                    <TableRow hover key={index}>
                                      <TableCell align="center">
                                        {value.analyte}
                                      </TableCell>
                                      <TableCell align="center">
                                        {value.data}
                                      </TableCell>
                                      <TableCell align="center">
                                        {value.cert}
                                      </TableCell>
                                      <TableCell align="center">
                                        {value.variance}
                                      </TableCell>
                                      <TableCell align="center">
                                        {value.zscore}
                                      </TableCell>
                                    </TableRow>
                                  ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </div>
                      </div>
                    </div>
                  </form>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      marginTop: "30px",
                      marginBottom: "30px",
                    }}
                  >
                    {/* Completed By section */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "48%",
                      }}
                    >
                      <label
                        htmlFor="signed"
                        style={{
                          fontFamily: "'Jost', sans-serif",
                          fontSize: "14px",
                          fontWeight: 400,
                          width: "94px",
                          color: "#20292F",
                          lineHeight: "25px",
                          margin: 0,
                        }}
                      >
                        Completed By:
                      </label>
                      <div
                        style={{
                          borderBottom: "1px solid #20292F",
                          paddingBottom: "2px",
                          marginLeft: "2px", // Small gap right after the label
                          flexGrow: 1, // Ensures underline stretches across the width
                        }}
                      >
                        <p
                          id="signed"
                          style={{
                            fontFamily: "'Jost', sans-serif",
                            fontSize: "14px",
                            fontWeight: 400,
                            color: "#20292F",
                            lineHeight: "20px",
                            margin: 0,
                            display: "inline-block",
                            whiteSpace: "nowrap",
                            fontStyle: "italic",
                          }}
                        >
                          {analyst}
                        </p>
                      </div>
                    </div>

                    {/* Date section */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "48%",
                      }}
                    >
                      <label
                        htmlFor="date"
                        style={{
                          fontFamily: "'Jost', sans-serif",
                          fontSize: "14px",
                          fontWeight: 400,
                          width: "40px",
                          color: "#20292F",
                          lineHeight: "25px",
                          margin: 0,
                        }}
                      >
                        Date:
                      </label>
                      <div
                        style={{
                          borderBottom: "1px solid #20292F",
                          paddingBottom: "2px",
                          marginLeft: "2px", // Small gap right after the label
                          flexGrow: 1, // Ensures underline stretches across the width
                        }}
                      >
                        <p
                          style={{
                            fontFamily: "'Jost', sans-serif",
                            fontSize: "14px",
                            fontWeight: 400,
                            color: "#20292F",
                            lineHeight: "20px",
                            margin: 0,
                            display: "inline-block",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {formatDate(date)}
                        </p>
                      </div>
                    </div>
                  </div>

                  <footer className="report-footer">
                    <div
                      style={{
                        backgroundColor: "#FFF",
                        color: "#000",
                        width: "100%",

                        boxSizing: "border-box",
                        fontFamily: "'Jost', sans-serif",
                        border: "1px solid #000",
                        borderCollapse: "collapse", // This ensures no gaps in borders
                      }}
                    >
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "16px",
                          lineHeight: "20px",
                          color: "#20292F !important",
                          // borderBottom: "1px solid #000",
                          paddingBottom: "5px",
                        }}
                      >
                        <h5
                          style={{
                            margin: 0,
                            fontWeight: 400,
                            color: "#20292F",
                            textDecoration: "none",
                          }}
                        >
                          521 Violet Street, Golden, CO 80401-6714
                        </h5>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          fontSize: "16px",
                          color: "#20292F",
                          lineHeight: "20px",
                          borderBottom: "1px solid #000",
                          padding: "5px 0",
                        }}
                      >
                        <span style={{ padding: "0 8px" }}>
                          (P): (720) 943-7676
                        </span>
                        <span style={{ padding: "0 8px" }}>
                          <span
                            style={{
                              display: "inline-block",
                              width: "8px",
                              height: "8px",
                              borderRadius: "50%",
                              backgroundColor: "#000",
                              margin: "0 8px",
                            }}
                          />
                        </span>
                        <span style={{ padding: "0 8px" }}>
                          (F): (720) 943-7670
                        </span>

                        <span style={{ padding: "0 8px" }}>
                          <span
                            style={{
                              display: "inline-block",
                              width: "8px",
                              height: "8px",
                              borderRadius: "50%",
                              backgroundColor: "#000",
                              margin: "0 8px",
                            }}
                          />
                        </span>
                        <span style={{ padding: "0 8px" }}>
                          <a
                            href="https://rmrms.com/"
                            style={{
                              textDecoration: "none",
                              color: "#20292F",
                            }}
                          >
                            www.RMRMs.com
                          </a>
                        </span>
                        <span style={{ padding: "0 8px" }}>
                          <span
                            style={{
                              display: "inline-block",
                              width: "8px",
                              height: "8px",
                              borderRadius: "50%",
                              backgroundColor: "#000",
                              margin: "0 8px",
                            }}
                          />
                        </span>
                        <span style={{ padding: "0 8px" }}>
                          <a
                            href="mailto:RMPT@RMRMs.com"
                            style={{
                              textDecoration: "none",
                              color: "#20292F",
                            }}
                          >
                            RMPT@RMRMs.com
                          </a>
                        </span>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontSize: "16px",
                          color: "#20292F",
                          lineHeight: "20px",
                        }}
                      >
                        <div
                          style={{
                            flex: 1,
                            textAlign: "center",
                            borderRight: "1px solid #000",
                            padding: "5px 0",
                          }}
                        >
                          <span>RMPT 190</span>
                        </div>
                        <div
                          style={{
                            flex: 2,
                            textAlign: "center",
                            borderRight: "1px solid #000",
                            padding: "5px 0",
                          }}
                        >
                          <span> Approved: </span>
                          <b>Daniel Geist</b>
                        </div>
                        <div
                          style={{
                            flex: 2,
                            textAlign: "center",
                            borderRight: "1px solid #000",
                            padding: "5px 0",
                          }}
                        >
                          <span> Issue Date: </span>
                          <b>09/01/2020</b>
                        </div>
                        <div
                          style={{
                            flex: 1,
                            textAlign: "center",
                            borderRight: "1px solid #000",
                            padding: "5px 0",
                          }}
                        >
                          <span> Issue #: </span>
                          <b>3</b>
                        </div>
                        <div
                          style={{
                            flex: 1,
                            textAlign: "center",
                            padding: "5px 0",
                          }}
                        >
                          <span> Page: </span>
                          <b>1</b> of <b>1</b>
                        </div>
                      </div>
                    </div>
                  </footer>
                </div>
              </section>
              <section
                style={{
                  background: "#fff",
                  border: isPrinting ? "none" : "",
                }}
                className={
                  isPrinting
                    ? "form__container page__section landscape mt_25"
                    : "form__container  page__section landscape mt_25"
                }
              >
                <div className="container-chart">
                  {/* Header */}
                  <header className="section__header">
                    <div
                      style={{ textDecoration: "none" }}
                      className="header__company"
                    >
                      Rocky Mountain Proficiency Testing - A Division of Rocky
                      Mountain Reference Materials
                    </div>
                  </header>

                  {/* Content with Chart */}
                  <div className="chart__container bordered-chart">
                    <Chart />
                  </div>

                  {/* Footer */}
                  <footer className="section__footer">
                    <div className="footer__info">
                      RMPT 190A - Approved: Daniel Geist - Issue Date:
                      09/01/2017 - Issue #: 2 Page: 2 of 2
                    </div>
                  </footer>
                </div>
              </section>

              <section className="page__section portrait">
                <div
                  style={{
                    border: isPrinting ? "none" : "",
                  }}
                  className="form__container"
                >
                  <form className="form form__user">
                    <div className="flex alignitems--center justifyspace--between">
                      <span className="highlightedText"></span>
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          handlePrint();
                        }}
                        className="btn--print"
                      >
                        <PrintOutlinedIcon />
                        Print this out!
                      </button>
                    </div>
                  </form>
                  <div
                    style={{
                      display: "flex",
                      marginBottom: "15px",
                      justifyContent: "space-around",
                    }}
                  >
                    <div className="alignment" style={{ lineHeight: "10px" }}>
                      <img
                        alt="RMRMs"
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAAA7CAMAAABYOMQ9AAABGlBMVEVHcExnZ2ekc4QwMDCHZXIJCgovLy8VFhaRfIMvLy8MDAyhOUUEBQSSCg+/h5uRCQ8BAQGAXmoJCwtIREaMAQIjJCSQFR0GBwcSFRUYGRkFBgYdHR2SMUKRNEpJSUqTN01uBg6IDRgEBgaWMEOqUF2ngIyXDBEvGh0uLzEJCQlcUFOUAwSKHSyOHS3Lk6McHx6lHyehGiCcPE6RBAU5OTlkZGSqYnE7OztCQkKcBwodGBkJDAyqY3Z/BhMwJyh7e3ugKDNVVVWjCg0QHR+nPkmLAABnZ2eRCQ8zDhevIygAAACZAACaAACYAACWAAGTAACPAACdAACiAQOpAAGuAQOHAQK5AAECAgezAQMsBQ0eAwkNAgg5BxBQBAztahv/AAAASnRSTlMAWhqmB+0y1A+5OoIfyyzC+gPFUeRQr9Vhji+BTypnO/6Z9HJoOd0XaHIk9mp/SLWr0GbsmUZchT/55qtCishUlYvywKPyPLf54JpLNPkAAASmSURBVHjardj7V9pIFAfwKwFlRdHwpqCIAgJqfa7ru9rWdpd5ZBKeiv7//8aSydBJCAEl+f7Qc8qcwyfXOzeZALYoDw8Pf3kln883GulqMwq+km3NTJ//G0kojdXFIXU/fpXLFS6UiPziH4V8XlGyEScXUdLgM2n5bUng2f9VV5xOwqeyttkaZ1t+Gv527FAU1Y+x7zRklh1K1g+y1nIbItt25DgYI+nulUw/HYjxxbWYtCErPvaw7McquKLYkCYsnBUvI27ur01p/B28EWOXzkKCN/Yo6m7xvRW4IQmM6HkIctJYC9jYIxghrP0HX9z7yr8hiRHCHrfl9ARhbC47CI4M3loiWQjCiETByuGYQIY+bIn8CtQ4Y2OC9Hb6YvEfCMLoC+MrQ+Pog1exmOBLpYDq+NqltjLGzeBLMVL2XwcnNIvAtNZjffEQVjmh6aziuw5JYKrF4FD8pYYZizA386W/OnajktCMPQjfWguvpF0GONLMzwkr+apjF+KCIPr3OKTFueG93SG0ciZwom35qWPl0mDYFEjnJBo6tj5M7PTaFGFmEjz6+b6POv41ECdwb72eF+42VFMcxnJDp8ILGy8dgyCEqNHb2bUfI6I/DwhyZGNR42XQpibRHrz3WzJVAKgR3ok/NzGWWcx46XAC6/hts2XLDcC6bn659niXEn3XtfLnDUmw0+TqWtKO5E90NMrBGUDolGFRSeyzhiS0DJgj/U0Sw24bI0x/h/gJNUMXQ1YkQY+ARyJDOqAYdSsjmqcsEMQuP2UIguj0EETUJTHixkDT2ye2sTtiOjeIVvqM8coJ2rm+A5kGJ9odrTN4dxzeKkw8hz8z8A94RBDS696ALWrDrKKDe/Rt4jFbEuOCn0MfJeLfDWrOdrcVcc5v7sXotAf8QXgB9jTFHia16AeJa0T4bPcnDDV03R4Yb/0pZ5LoOu+8zmrqh4hnDYvZFoasTzd2huMjy8QVn3AEa79hfsLndER02m/8OajaqogzWivV5RshOHOEdDJCUGY+sU4wIT3yal1s09ZYxMphgIIg3OeSQ4bwCMH3cwnMuz10nRMr3YMimJHIFThTvLZ2cGwegRHq7PRd71GxbkY0QCK7k5toK2WdiStzqsAUFX+0Jo1q6gxEJLI50RJxi8REK84gdIRJKg4Jl+GcrYJXS0DN8Eq6JQ9CXdcxZhshiEachjsFz5cclW8vchD3IhDWTma918rk5JS4EI1grJ2HPKpAWgxcxmwkC64UdYQwq00leK9cxjxEcX9VPEUx1tzHiA0d41R17u8MMuqV+FWr7l4KnWoYk4yLGMEh+ZuMNLxT3Z0+ivwJbM5ZeYJA7Ke8U8vDVNqbUKEZsUZxWnsfzcbHHAShe/K/ywKY+zq2n7VO92Fw5whhzCp2ghXlaignjafoTERNTLkFy1dIzIqyF7Wq2erVeu5JSWQdB7bNbOL2qZ5Lr3koFy0ztzAldwcIk5JFGNoGv9qb1oxEVA+kwZcvYEqaKao/bwFsnRtUdLuQX+JJLtuyZCWfD4NHVm88X3Kjp8Sgd1DMlM/AT9Rw9JZXMu0iwvf35UMIJOljpVEPe23x/wEqEQiHo1JPFQAAAABJRU5ErkJggg=="
                        style={{
                          display: "block",
                          height: "auto",
                          border: 0,
                          width: "100px",
                          maxWidth: "100%",
                        }}
                        title="RMRMs"
                        width="195"
                      />
                    </div>
                    <div>
                      <h2
                        style={{
                          color: "#000",
                          fontFamily: "'Jost', sans-serif",
                          fontSize: "24px",
                          fontWeight: 500,
                          letterSpacing: "normal",
                          lineHeight: "32px",
                          margin: 0,
                          textAlign: "center",
                        }}
                      >
                        Rocky Mountain Proficiency Testing
                      </h2>
                      <p
                        style={{
                          color: "#000",
                          fontFamily: "'Jost', sans-serif",
                          fontSize: "18px",
                          fontWeight: 400,
                          letterSpacing: "normal",
                          lineHeight: "32px",
                          margin: 0,
                          textAlign: "center",
                        }}
                      >
                        A Division of Rocky Mountain Reference Materials
                      </p>
                    </div>
                    <div className="alignment" style={{ lineHeight: "10px" }}>
                      <img
                        alt="RMRMs"
                        src="data:image/png;base64,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"
                        style={{
                          display: "block",
                          height: "auto",
                          border: 0,
                          width: "100px",
                          maxWidth: "100%",
                        }}
                        title="NVLAP LAB CODE 200111-0"
                        width="177"
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginBottom: "15px",
                    }}
                  >
                    <h2
                      style={{
                        fontFamily: "'Jost', sans-serif",
                        fontSize: "24px",
                        fontWeight: 500,
                        letterSpacing: "normal",
                        lineHeight: "25px",
                        color: "#20292F",
                        margin: "0 0 10px 0",
                        textDecoration: "underline",
                        textAlign: "center",
                      }}
                    >
                      Amended Z-Score Summary Report Form
                    </h2>
                  </div>

                  <header className="report-header">
                    <div className="header-left">
                      <p>(F): (720) 943-7670</p>
                      <p>RMPT@RMRMs.com</p>
                      <p>Attn: RMPT Processing Dept.</p>
                      <p>October 19, 2018</p>
                      <p style={{ fontWeight: "bold" }}>
                        Amended Z - Score generated for RMPT#
                        <span className="highlightedText">
                          {rmptId}
                          -1
                        </span>
                      </p>
                    </div>
                    <div className="header-right">
                      <p>{firstName}</p>
                      <p>{address}</p>
                      <p>
                        {state}, {city} {zip}
                      </p>
                      <p>
                        (P:) {telephone} (F:) {fax}
                      </p>
                      <p>{email}</p>
                    </div>
                  </header>

                  <form className="form form__user">
                    <div
                      style={{
                        height: "100%",
                        width: "100%",
                        overflowY: "auto",
                      }}
                      id="printablediv"
                    >
                      <div className="zscore-container">
                        <div className="zscore-column">
                          <TableContainer className="form__table form__zscore">
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell align="center">Analyte</TableCell>
                                  <TableCell align="center">Data</TableCell>
                                  <TableCell align="center">Cert</TableCell>
                                  <TableCell align="center">Variance</TableCell>
                                  <TableCell align="center">Z-Score</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {amendedData
                                  .slice(0, Math.ceil(data.length / 2))
                                  .map((value, index) => (
                                    <TableRow hover key={index}>
                                      <TableCell align="center">
                                        {value.analyte}
                                      </TableCell>
                                      <TableCell align="center">
                                        {value.data}
                                      </TableCell>
                                      <TableCell align="center">
                                        {value.cert}
                                      </TableCell>
                                      <TableCell align="center">
                                        {value.variance}
                                      </TableCell>
                                      <TableCell align="center">
                                        {value.zscore}
                                      </TableCell>
                                    </TableRow>
                                  ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </div>

                        <div className="zscore-column">
                          <TableContainer className="form__table form__zscore">
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell align="center">Analyte</TableCell>
                                  <TableCell align="center">Data</TableCell>
                                  <TableCell align="center">Cert</TableCell>
                                  <TableCell align="center">Variance</TableCell>
                                  <TableCell align="center">Z-Score</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {amendedData
                                  .slice(
                                    Math.ceil(data.length / 2),
                                    data.length
                                  )
                                  .map((value, index) => (
                                    <TableRow hover key={index}>
                                      <TableCell align="center">
                                        {value.analyte}
                                      </TableCell>
                                      <TableCell align="center">
                                        {value.data}
                                      </TableCell>
                                      <TableCell align="center">
                                        {value.cert}
                                      </TableCell>
                                      <TableCell align="center">
                                        {value.variance}
                                      </TableCell>
                                      <TableCell align="center">
                                        {value.zscore}
                                      </TableCell>
                                    </TableRow>
                                  ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </div>
                      </div>
                    </div>
                  </form>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      marginTop: "30px",
                      marginBottom: "30px",
                    }}
                  >
                    {/* Completed By section */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "48%",
                      }}
                    >
                      <label
                        htmlFor="signed"
                        style={{
                          fontFamily: "'Jost', sans-serif",
                          fontSize: "14px",
                          fontWeight: 400,
                          width: "94px",
                          color: "#20292F",
                          lineHeight: "25px",
                          margin: 0,
                        }}
                      >
                        Completed By:
                      </label>
                      <div
                        style={{
                          borderBottom: "1px solid #20292F",
                          paddingBottom: "2px",
                          marginLeft: "2px", // Small gap right after the label
                          flexGrow: 1, // Ensures underline stretches across the width
                        }}
                      >
                        <p
                          id="signed"
                          style={{
                            fontFamily: "'Jost', sans-serif",
                            fontSize: "14px",
                            fontWeight: 400,
                            color: "#20292F",
                            lineHeight: "20px",
                            margin: 0,
                            display: "inline-block",
                            whiteSpace: "nowrap",
                            fontStyle: "italic",
                          }}
                        >
                          {amendedAnalyst}
                        </p>
                      </div>
                    </div>

                    {/* Date section */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "48%",
                      }}
                    >
                      <label
                        htmlFor="date"
                        style={{
                          fontFamily: "'Jost', sans-serif",
                          fontSize: "14px",
                          fontWeight: 400,
                          width: "40px",
                          color: "#20292F",
                          lineHeight: "25px",
                          margin: 0,
                        }}
                      >
                        Date:
                      </label>
                      <div
                        style={{
                          borderBottom: "1px solid #20292F",
                          paddingBottom: "2px",
                          marginLeft: "2px", // Small gap right after the label
                          flexGrow: 1, // Ensures underline stretches across the width
                        }}
                      >
                        <p
                          style={{
                            fontFamily: "'Jost', sans-serif",
                            fontSize: "14px",
                            fontWeight: 400,
                            color: "#20292F",
                            lineHeight: "20px",
                            margin: 0,
                            display: "inline-block",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {formatDate(amendedDate)}
                        </p>
                      </div>
                    </div>
                  </div>

                  <footer className="report-footer">
                    <div
                      style={{
                        backgroundColor: "#FFF",
                        color: "#000",
                        width: "100%",

                        boxSizing: "border-box",
                        fontFamily: "'Jost', sans-serif",
                        border: "1px solid #000",
                        borderCollapse: "collapse", // This ensures no gaps in borders
                      }}
                    >
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "16px",
                          lineHeight: "20px",
                          color: "#20292F !important",
                          // borderBottom: "1px solid #000",
                          paddingBottom: "5px",
                        }}
                      >
                        <h5
                          style={{
                            margin: 0,
                            fontWeight: 400,
                            color: "#20292F",
                            textDecoration: "none",
                          }}
                        >
                          521 Violet Street, Golden, CO 80401-6714
                        </h5>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          fontSize: "16px",
                          color: "#20292F",
                          lineHeight: "20px",
                          borderBottom: "1px solid #000",
                          padding: "5px 0",
                        }}
                      >
                        <span style={{ padding: "0 8px" }}>
                          (P): (720) 943-7676
                        </span>
                        <span style={{ padding: "0 8px" }}>
                          <span
                            style={{
                              display: "inline-block",
                              width: "8px",
                              height: "8px",
                              borderRadius: "50%",
                              backgroundColor: "#000",
                              margin: "0 8px",
                            }}
                          />
                        </span>
                        <span style={{ padding: "0 8px" }}>
                          (F): (720) 943-7670
                        </span>

                        <span style={{ padding: "0 8px" }}>
                          <span
                            style={{
                              display: "inline-block",
                              width: "8px",
                              height: "8px",
                              borderRadius: "50%",
                              backgroundColor: "#000",
                              margin: "0 8px",
                            }}
                          />
                        </span>
                        <span style={{ padding: "0 8px" }}>
                          <a
                            href="https://rmrms.com/"
                            style={{
                              textDecoration: "none",
                              color: "#20292F",
                            }}
                          >
                            www.RMRMs.com
                          </a>
                        </span>
                        <span style={{ padding: "0 8px" }}>
                          <span
                            style={{
                              display: "inline-block",
                              width: "8px",
                              height: "8px",
                              borderRadius: "50%",
                              backgroundColor: "#000",
                              margin: "0 8px",
                            }}
                          />
                        </span>
                        <span style={{ padding: "0 8px" }}>
                          <a
                            href="mailto:RMPT@RMRMs.com"
                            style={{
                              textDecoration: "none",
                              color: "#20292F",
                            }}
                          >
                            RMPT@RMRMs.com
                          </a>
                        </span>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontSize: "16px",
                          color: "#20292F",
                          lineHeight: "20px",
                        }}
                      >
                        <div
                          style={{
                            flex: 1,
                            textAlign: "center",
                            borderRight: "1px solid #000",
                            padding: "5px 0",
                          }}
                        >
                          <span>RMPT 193</span>
                        </div>
                        <div
                          style={{
                            flex: 2,
                            textAlign: "center",
                            borderRight: "1px solid #000",
                            padding: "5px 0",
                          }}
                        >
                          <span> Approved: </span>
                          <b>Daniel Geist</b>
                        </div>
                        <div
                          style={{
                            flex: 2,
                            textAlign: "center",
                            borderRight: "1px solid #000",
                            padding: "5px 0",
                          }}
                        >
                          <span> Issue Date: </span>
                          <b>09/01/2020</b>
                        </div>
                        <div
                          style={{
                            flex: 1,
                            textAlign: "center",
                            borderRight: "1px solid #000",
                            padding: "5px 0",
                          }}
                        >
                          <span> Issue #: </span>
                          <b>3</b>
                        </div>
                        <div
                          style={{
                            flex: 1,
                            textAlign: "center",
                            padding: "5px 0",
                          }}
                        >
                          <span> Page: </span>
                          <b>3</b> of <b>3</b>
                        </div>
                      </div>
                    </div>
                  </footer>
                </div>
              </section>
              <section
                style={{
                  background: "#fff",
                  border: isPrinting ? "none" : "",
                }}
                className={
                  isPrinting
                    ? "form__container page__section landscape mt_25"
                    : "form__container  page__section landscape mt_25"
                }
              >
                <div className="container-chart">
                  {/* Header */}
                  <header className="section__header">
                    <div
                      style={{ textDecoration: "none" }}
                      className="header__company"
                    >
                      Rocky Mountain Proficiency Testing - A Division of Rocky
                      Mountain Reference Materials
                    </div>
                  </header>

                  {/* Content with Chart */}
                  <div className="chart__container bordered-chart">
                    <AmendedChart ref={amendedComponentRef} />
                  </div>

                  {/* Footer */}
                  <footer className="section__footer">
                    <div className="footer__info">
                      RMPT 193A - Approved: Daniel Geist - Issue Date:
                      09/01/2017 - Issue #: 2 Page: 4 of 4
                    </div>
                  </footer>
                </div>
              </section>
            </div>
          </div>
        ) : null}
        {(localStorage.getItem("type") &&
          localStorage.getItem("type") === "appeal") ||
        (localStorage.getItem("type") === "finalreport" &&
          localStorage.getItem("reappealed") === "no") ? (
          <div id="app" className="app" ref={componentRef}>
            {" "}
            <div class="first-page-wrapper">
              <section className="page__section portrait">
                <div
                  style={{ border: isPrinting ? "none" : "" }}
                  className="form__container"
                >
                  <form className="form form__user">
                    <div className="flex alignitems--center justifyspace--between">
                      <span className="highlightedText"></span>

                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          handlePrint();
                        }}
                        className="btn--print"
                      >
                        <PrintOutlinedIcon />
                        Print this out!
                      </button>
                    </div>
                  </form>
                  <div
                    style={{
                      display: "flex",
                      marginBottom: "15px",
                      justifyContent: "space-around",
                    }}
                  >
                    <div className="alignment" style={{ lineHeight: "10px" }}>
                      <img
                        alt="RMRMs"
                        src="data:image/png;base64,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"
                        style={{
                          display: "block",
                          height: "auto",
                          border: 0,
                          width: "100px",
                          maxWidth: "100%",
                        }}
                        title="RMRMs"
                        width="195"
                      />
                    </div>
                    <div>
                      <h2
                        style={{
                          color: "#000",
                          fontFamily: "'Jost', sans-serif",
                          fontSize: "24px",
                          fontWeight: 500,
                          letterSpacing: "normal",
                          lineHeight: "32px",
                          margin: 0,
                          textAlign: "center",
                        }}
                      >
                        Rocky Mountain Proficiency Testing
                      </h2>
                      <p
                        style={{
                          color: "#000",
                          fontFamily: "'Jost', sans-serif",
                          fontSize: "18px",
                          fontWeight: 400,
                          letterSpacing: "normal",
                          lineHeight: "32px",
                          margin: 0,
                          textAlign: "center",
                        }}
                      >
                        A Division of Rocky Mountain Reference Materials
                      </p>
                    </div>
                    <div className="alignment" style={{ lineHeight: "10px" }}>
                      <img
                        alt="RMRMs"
                        src="data:image/png;base64,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"
                        style={{
                          display: "block",
                          height: "auto",
                          border: 0,
                          width: "100px",
                          maxWidth: "100%",
                        }}
                        title="NVLAP LAB CODE 200111-0"
                        width="177"
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginBottom: "15px",
                    }}
                  >
                    <h2
                      style={{
                        fontFamily: "'Jost', sans-serif",
                        fontSize: "24px",
                        fontWeight: 500,
                        letterSpacing: "normal",
                        lineHeight: "25px",
                        color: "#20292F",
                        margin: "0 0 10px 0",
                        textDecoration: "underline",
                        textAlign: "center",
                      }}
                    >
                      RMPT Z-Score Summary Report Form
                    </h2>
                  </div>

                  <header className="report-header">
                    <div className="header-left">
                      <p>(F): (720) 943-7670</p>
                      <p>RMPT@RMRMs.com</p>
                      <p>Attn: RMPT Processing Dept.</p>
                      <p>October 19, 2018</p>
                      <p style={{ fontWeight: "bold" }}>
                        Results for RMPT#
                        <span className="highlightedText">{rmptId}</span>
                      </p>
                    </div>
                    <div className="header-right">
                      <p>{firstName}</p>
                      <p>{address}</p>
                      <p>
                        {state}, {city} {zip}
                      </p>
                      <p>
                        (P:) {telephone} (F:) {fax}
                      </p>
                      <p>{email}</p>
                    </div>
                  </header>

                  <form className="form form__user">
                    <div
                      style={{
                        minHeight: "100%",
                        width: "100%",
                        overflowY: "auto",
                      }}
                      id="printablediv"
                    >
                      <div className="zscore-container">
                        <div className="zscore-column">
                          <TableContainer className="form__table form__zscore">
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell align="center">Analyte</TableCell>
                                  <TableCell align="center">Data</TableCell>
                                  <TableCell align="center">Cert</TableCell>
                                  <TableCell align="center">Variance</TableCell>
                                  <TableCell align="center">Z-Score</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {data
                                  .slice(0, Math.ceil(data.length / 2))
                                  .map((value, index) => (
                                    <TableRow hover key={index}>
                                      <TableCell align="center">
                                        {value.analyte}
                                      </TableCell>
                                      <TableCell align="center">
                                        {value.data}
                                      </TableCell>
                                      <TableCell align="center">
                                        {value.cert}
                                      </TableCell>
                                      <TableCell align="center">
                                        {value.variance}
                                      </TableCell>
                                      <TableCell align="center">
                                        {value.zscore}
                                      </TableCell>
                                    </TableRow>
                                  ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </div>

                        <div className="zscore-column">
                          <TableContainer className="form__table form__zscore">
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell align="center">Analyte</TableCell>
                                  <TableCell align="center">Data</TableCell>
                                  <TableCell align="center">Cert</TableCell>
                                  <TableCell align="center">Variance</TableCell>
                                  <TableCell align="center">Z-Score</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {data
                                  .slice(
                                    Math.ceil(data.length / 2),
                                    data.length
                                  )
                                  .map((value, index) => (
                                    <TableRow hover key={index}>
                                      <TableCell align="center">
                                        {value.analyte}
                                      </TableCell>
                                      <TableCell align="center">
                                        {value.data}
                                      </TableCell>
                                      <TableCell align="center">
                                        {value.cert}
                                      </TableCell>
                                      <TableCell align="center">
                                        {value.variance}
                                      </TableCell>
                                      <TableCell align="center">
                                        {value.zscore}
                                      </TableCell>
                                    </TableRow>
                                  ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </div>
                      </div>
                    </div>
                  </form>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      marginTop: "30px",
                      marginBottom: "30px",
                    }}
                  >
                    {/* Completed By section */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "48%",
                      }}
                    >
                      <label
                        htmlFor="signed"
                        style={{
                          fontFamily: "'Jost', sans-serif",
                          fontSize: "14px",
                          fontWeight: 400,
                          width: "94px",
                          color: "#20292F",
                          lineHeight: "25px",
                          margin: 0,
                        }}
                      >
                        Completed By:
                      </label>
                      <div
                        style={{
                          borderBottom: "1px solid #20292F",
                          paddingBottom: "2px",
                          marginLeft: "2px", // Small gap right after the label
                          flexGrow: 1, // Ensures underline stretches across the width
                        }}
                      >
                        <p
                          id="signed"
                          style={{
                            fontFamily: "'Jost', sans-serif",
                            fontSize: "14px",
                            fontWeight: 400,
                            color: "#20292F",
                            lineHeight: "20px",
                            margin: 0,
                            display: "inline-block",
                            whiteSpace: "nowrap",
                            fontStyle: "italic",
                          }}
                        >
                          {analyst}
                        </p>
                      </div>
                    </div>

                    {/* Date section */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "48%",
                      }}
                    >
                      <label
                        htmlFor="date"
                        style={{
                          fontFamily: "'Jost', sans-serif",
                          fontSize: "14px",
                          fontWeight: 400,
                          width: "40px",
                          color: "#20292F",
                          lineHeight: "25px",
                          margin: 0,
                        }}
                      >
                        Date:
                      </label>
                      <div
                        style={{
                          borderBottom: "1px solid #20292F",
                          paddingBottom: "2px",
                          marginLeft: "2px", // Small gap right after the label
                          flexGrow: 1, // Ensures underline stretches across the width
                        }}
                      >
                        <p
                          style={{
                            fontFamily: "'Jost', sans-serif",
                            fontSize: "14px",
                            fontWeight: 400,
                            color: "#20292F",
                            lineHeight: "20px",
                            margin: 0,
                            display: "inline-block",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {formatDate(date)}
                        </p>
                      </div>
                    </div>
                  </div>

                  <footer className="report-footer">
                    <div
                      style={{
                        backgroundColor: "#FFF",
                        color: "#000",
                        width: "100%",

                        boxSizing: "border-box",
                        fontFamily: "'Jost', sans-serif",
                        border: "1px solid #000",
                        borderCollapse: "collapse", // This ensures no gaps in borders
                      }}
                    >
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "16px",
                          lineHeight: "20px",
                          color: "#20292F !important",
                          // borderBottom: "1px solid #000",
                          paddingBottom: "5px",
                        }}
                      >
                        <h5
                          style={{
                            margin: 0,
                            fontWeight: 400,
                            color: "#20292F",
                            textDecoration: "none",
                          }}
                        >
                          521 Violet Street, Golden, CO 80401-6714
                        </h5>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          fontSize: "16px",
                          color: "#20292F",
                          lineHeight: "20px",
                          borderBottom: "1px solid #000",
                          padding: "5px 0",
                        }}
                      >
                        <span style={{ padding: "0 8px" }}>
                          (P): (720) 943-7676
                        </span>
                        <span style={{ padding: "0 8px" }}>
                          <span
                            style={{
                              display: "inline-block",
                              width: "8px",
                              height: "8px",
                              borderRadius: "50%",
                              backgroundColor: "#000",
                              margin: "0 8px",
                            }}
                          />
                        </span>
                        <span style={{ padding: "0 8px" }}>
                          (F): (720) 943-7670
                        </span>

                        <span style={{ padding: "0 8px" }}>
                          <span
                            style={{
                              display: "inline-block",
                              width: "8px",
                              height: "8px",
                              borderRadius: "50%",
                              backgroundColor: "#000",
                              margin: "0 8px",
                            }}
                          />
                        </span>
                        <span style={{ padding: "0 8px" }}>
                          <a
                            href="https://rmrms.com/"
                            style={{
                              textDecoration: "none",
                              color: "#20292F",
                            }}
                          >
                            www.RMRMs.com
                          </a>
                        </span>
                        <span style={{ padding: "0 8px" }}>
                          <span
                            style={{
                              display: "inline-block",
                              width: "8px",
                              height: "8px",
                              borderRadius: "50%",
                              backgroundColor: "#000",
                              margin: "0 8px",
                            }}
                          />
                        </span>
                        <span style={{ padding: "0 8px" }}>
                          <a
                            href="mailto:RMPT@RMRMs.com"
                            style={{
                              textDecoration: "none",
                              color: "#20292F",
                            }}
                          >
                            RMPT@RMRMs.com
                          </a>
                        </span>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontSize: "16px",
                          color: "#20292F",
                          lineHeight: "20px",
                        }}
                      >
                        <div
                          style={{
                            flex: 1,
                            textAlign: "center",
                            borderRight: "1px solid #000",
                            padding: "5px 0",
                          }}
                        >
                          <span>RMPT 190</span>
                        </div>
                        <div
                          style={{
                            flex: 2,
                            textAlign: "center",
                            borderRight: "1px solid #000",
                            padding: "5px 0",
                          }}
                        >
                          <span> Approved: </span>
                          <b>Daniel Geist</b>
                        </div>
                        <div
                          style={{
                            flex: 2,
                            textAlign: "center",
                            borderRight: "1px solid #000",
                            padding: "5px 0",
                          }}
                        >
                          <span> Issue Date: </span>
                          <b>09/01/2020</b>
                        </div>
                        <div
                          style={{
                            flex: 1,
                            textAlign: "center",
                            borderRight: "1px solid #000",
                            padding: "5px 0",
                          }}
                        >
                          <span> Issue #: </span>
                          <b>3</b>
                        </div>
                        <div
                          style={{
                            flex: 1,
                            textAlign: "center",
                            padding: "5px 0",
                          }}
                        >
                          <span> Page: </span>
                          <b>1</b> of <b>1</b>
                        </div>
                      </div>
                    </div>
                  </footer>
                </div>
              </section>
              <section
                style={{
                  background: "#fff",
                  border: isPrinting ? "none" : "",
                }}
                className={
                  isPrinting
                    ? "form__container page__section landscape mt_25"
                    : "form__container  page__section landscape mt_25"
                }
              >
                <div className="container-chart">
                  {/* Header */}
                  <header className="section__header">
                    <div
                      style={{ textDecoration: "none" }}
                      className="header__company"
                    >
                      Rocky Mountain Proficiency Testing - A Division of Rocky
                      Mountain Reference Materials
                    </div>
                  </header>

                  {/* Content with Chart */}
                  <div className="chart__container bordered-chart">
                    <Chart />
                  </div>

                  {/* Footer */}
                  <footer className="section__footer">
                    <div className="footer__info">
                      RMPT 190A - Approved: Daniel Geist - Issue Date:
                      09/01/2017 - Issue #: 2 Page: 2 of 2
                    </div>
                  </footer>
                </div>
              </section>
            </div>
          </div>
        ) : null}

        {localStorage.getItem("type") &&
        localStorage.getItem("type") === "reappeal" ? (
          <div id="app" className="app" ref={componentRef}>
            {" "}
            <div class="first-page-wrapper">
              <section className="page__section portrait">
                <div
                  style={{
                    border: isPrinting ? "none" : "",
                  }}
                  className="form__container"
                >
                  <form className="form form__user">
                    <div className="flex alignitems--center justifyspace--between">
                      <span className="highlightedText"></span>
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          handlePrint();
                        }}
                        className="btn--print"
                      >
                        <PrintOutlinedIcon />
                        Print this out!
                      </button>
                    </div>
                  </form>
                  <div
                    style={{
                      display: "flex",
                      marginBottom: "15px",
                      justifyContent: "space-around",
                    }}
                  >
                    <div className="alignment" style={{ lineHeight: "10px" }}>
                      <img
                        alt="RMRMs"
                        src="data:image/png;base64,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"
                        style={{
                          display: "block",
                          height: "auto",
                          border: 0,
                          width: "100px",
                          maxWidth: "100%",
                        }}
                        title="RMRMs"
                        width="195"
                      />
                    </div>
                    <div>
                      <h2
                        style={{
                          color: "#000",
                          fontFamily: "'Jost', sans-serif",
                          fontSize: "24px",
                          fontWeight: 500,
                          letterSpacing: "normal",
                          lineHeight: "32px",
                          margin: 0,
                          textAlign: "center",
                        }}
                      >
                        Rocky Mountain Proficiency Testing
                      </h2>
                      <p
                        style={{
                          color: "#000",
                          fontFamily: "'Jost', sans-serif",
                          fontSize: "18px",
                          fontWeight: 400,
                          letterSpacing: "normal",
                          lineHeight: "32px",
                          margin: 0,
                          textAlign: "center",
                        }}
                      >
                        A Division of Rocky Mountain Reference Materials
                      </p>
                    </div>
                    <div className="alignment" style={{ lineHeight: "10px" }}>
                      <img
                        alt="RMRMs"
                        src="data:image/png;base64,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"
                        style={{
                          display: "block",
                          height: "auto",
                          border: 0,
                          width: "100px",
                          maxWidth: "100%",
                        }}
                        title="NVLAP LAB CODE 200111-0"
                        width="177"
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginBottom: "15px",
                    }}
                  >
                    <h2
                      style={{
                        fontFamily: "'Jost', sans-serif",
                        fontSize: "24px",
                        fontWeight: 500,
                        letterSpacing: "normal",
                        lineHeight: "25px",
                        color: "#20292F",
                        margin: "0 0 10px 0",
                        textDecoration: "underline",
                        textAlign: "center",
                      }}
                    >
                      Amended Z-Score Summary Report Form
                    </h2>
                  </div>

                  <header className="report-header">
                    <div className="header-left">
                      <p>(F): (720) 943-7670</p>
                      <p>RMPT@RMRMs.com</p>
                      <p>Attn: RMPT Processing Dept.</p>
                      <p>October 19, 2018</p>
                      <p style={{ fontWeight: "bold" }}>
                        Amended Z - Score generated for RMPT#
                        <span className="highlightedText">
                          {rmptId}
                          -1
                        </span>
                      </p>
                    </div>
                    <div className="header-right">
                      <p>{firstName}</p>
                      <p>{address}</p>
                      <p>
                        {state}, {city} {zip}
                      </p>
                      <p>
                        (P:) {telephone} (F:) {fax}
                      </p>
                      <p>{email}</p>
                    </div>
                  </header>

                  <form className="form form__user">
                    <div
                      style={{
                        height: "100%",
                        width: "100%",
                        overflowY: "auto",
                      }}
                      id="printablediv"
                    >
                      <div className="zscore-container">
                        <div className="zscore-column">
                          <TableContainer className="form__table form__zscore">
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell align="center">Analyte</TableCell>
                                  <TableCell align="center">Data</TableCell>
                                  <TableCell align="center">Cert</TableCell>
                                  <TableCell align="center">Variance</TableCell>
                                  <TableCell align="center">Z-Score</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {amendedData
                                  .slice(0, Math.ceil(data.length / 2))
                                  .map((value, index) => (
                                    <TableRow hover key={index}>
                                      <TableCell align="center">
                                        {value.analyte}
                                      </TableCell>
                                      <TableCell align="center">
                                        {value.data}
                                      </TableCell>
                                      <TableCell align="center">
                                        {value.cert}
                                      </TableCell>
                                      <TableCell align="center">
                                        {value.variance}
                                      </TableCell>
                                      <TableCell align="center">
                                        {value.zscore}
                                      </TableCell>
                                    </TableRow>
                                  ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </div>

                        <div className="zscore-column">
                          <TableContainer className="form__table form__zscore">
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell align="center">Analyte</TableCell>
                                  <TableCell align="center">Data</TableCell>
                                  <TableCell align="center">Cert</TableCell>
                                  <TableCell align="center">Variance</TableCell>
                                  <TableCell align="center">Z-Score</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {amendedData
                                  .slice(
                                    Math.ceil(data.length / 2),
                                    data.length
                                  )
                                  .map((value, index) => (
                                    <TableRow hover key={index}>
                                      <TableCell align="center">
                                        {value.analyte}
                                      </TableCell>
                                      <TableCell align="center">
                                        {value.data}
                                      </TableCell>
                                      <TableCell align="center">
                                        {value.cert}
                                      </TableCell>
                                      <TableCell align="center">
                                        {value.variance}
                                      </TableCell>
                                      <TableCell align="center">
                                        {value.zscore}
                                      </TableCell>
                                    </TableRow>
                                  ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </div>
                      </div>
                    </div>
                  </form>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      marginTop: "30px",
                      marginBottom: "30px",
                    }}
                  >
                    {/* Completed By section */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "48%",
                      }}
                    >
                      <label
                        htmlFor="signed"
                        style={{
                          fontFamily: "'Jost', sans-serif",
                          fontSize: "14px",
                          fontWeight: 400,
                          width: "94px",
                          color: "#20292F",
                          lineHeight: "25px",
                          margin: 0,
                        }}
                      >
                        Completed By:
                      </label>
                      <div
                        style={{
                          borderBottom: "1px solid #20292F",
                          paddingBottom: "2px",
                          marginLeft: "2px", // Small gap right after the label
                          flexGrow: 1, // Ensures underline stretches across the width
                        }}
                      >
                        <p
                          id="signed"
                          style={{
                            fontFamily: "'Jost', sans-serif",
                            fontSize: "14px",
                            fontWeight: 400,
                            color: "#20292F",
                            lineHeight: "20px",
                            margin: 0,
                            display: "inline-block",
                            whiteSpace: "nowrap",
                            fontStyle: "italic",
                          }}
                        >
                          {amendedAnalyst}
                        </p>
                      </div>
                    </div>

                    {/* Date section */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "48%",
                      }}
                    >
                      <label
                        htmlFor="date"
                        style={{
                          fontFamily: "'Jost', sans-serif",
                          fontSize: "14px",
                          fontWeight: 400,
                          width: "40px",
                          color: "#20292F",
                          lineHeight: "25px",
                          margin: 0,
                        }}
                      >
                        Date:
                      </label>
                      <div
                        style={{
                          borderBottom: "1px solid #20292F",
                          paddingBottom: "2px",
                          marginLeft: "2px", // Small gap right after the label
                          flexGrow: 1, // Ensures underline stretches across the width
                        }}
                      >
                        <p
                          style={{
                            fontFamily: "'Jost', sans-serif",
                            fontSize: "14px",
                            fontWeight: 400,
                            color: "#20292F",
                            lineHeight: "20px",
                            margin: 0,
                            display: "inline-block",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {formatDate(amendedDate)}
                        </p>
                      </div>
                    </div>
                  </div>

                  <footer className="report-footer">
                    <div
                      style={{
                        backgroundColor: "#FFF",
                        color: "#000",
                        width: "100%",

                        boxSizing: "border-box",
                        fontFamily: "'Jost', sans-serif",
                        border: "1px solid #000",
                        borderCollapse: "collapse", // This ensures no gaps in borders
                      }}
                    >
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "16px",
                          lineHeight: "20px",
                          color: "#20292F !important",
                          // borderBottom: "1px solid #000",
                          paddingBottom: "5px",
                        }}
                      >
                        <h5
                          style={{
                            margin: 0,
                            fontWeight: 400,
                            color: "#20292F",
                            textDecoration: "none",
                          }}
                        >
                          521 Violet Street, Golden, CO 80401-6714
                        </h5>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          fontSize: "16px",
                          color: "#20292F",
                          lineHeight: "20px",
                          borderBottom: "1px solid #000",
                          padding: "5px 0",
                        }}
                      >
                        <span style={{ padding: "0 8px" }}>
                          (P): (720) 943-7676
                        </span>
                        <span style={{ padding: "0 8px" }}>
                          <span
                            style={{
                              display: "inline-block",
                              width: "8px",
                              height: "8px",
                              borderRadius: "50%",
                              backgroundColor: "#000",
                              margin: "0 8px",
                            }}
                          />
                        </span>
                        <span style={{ padding: "0 8px" }}>
                          (F): (720) 943-7670
                        </span>

                        <span style={{ padding: "0 8px" }}>
                          <span
                            style={{
                              display: "inline-block",
                              width: "8px",
                              height: "8px",
                              borderRadius: "50%",
                              backgroundColor: "#000",
                              margin: "0 8px",
                            }}
                          />
                        </span>
                        <span style={{ padding: "0 8px" }}>
                          <a
                            href="https://rmrms.com/"
                            style={{
                              textDecoration: "none",
                              color: "#20292F",
                            }}
                          >
                            www.RMRMs.com
                          </a>
                        </span>
                        <span style={{ padding: "0 8px" }}>
                          <span
                            style={{
                              display: "inline-block",
                              width: "8px",
                              height: "8px",
                              borderRadius: "50%",
                              backgroundColor: "#000",
                              margin: "0 8px",
                            }}
                          />
                        </span>
                        <span style={{ padding: "0 8px" }}>
                          <a
                            href="mailto:RMPT@RMRMs.com"
                            style={{
                              textDecoration: "none",
                              color: "#20292F",
                            }}
                          >
                            RMPT@RMRMs.com
                          </a>
                        </span>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontSize: "16px",
                          color: "#20292F",
                          lineHeight: "20px",
                        }}
                      >
                        <div
                          style={{
                            flex: 1,
                            textAlign: "center",
                            borderRight: "1px solid #000",
                            padding: "5px 0",
                          }}
                        >
                          <span>RMPT 193</span>
                        </div>
                        <div
                          style={{
                            flex: 2,
                            textAlign: "center",
                            borderRight: "1px solid #000",
                            padding: "5px 0",
                          }}
                        >
                          <span> Approved: </span>
                          <b>Daniel Geist</b>
                        </div>
                        <div
                          style={{
                            flex: 2,
                            textAlign: "center",
                            borderRight: "1px solid #000",
                            padding: "5px 0",
                          }}
                        >
                          <span> Issue Date: </span>
                          <b>09/01/2020</b>
                        </div>
                        <div
                          style={{
                            flex: 1,
                            textAlign: "center",
                            borderRight: "1px solid #000",
                            padding: "5px 0",
                          }}
                        >
                          <span> Issue #: </span>
                          <b>3</b>
                        </div>
                        <div
                          style={{
                            flex: 1,
                            textAlign: "center",
                            padding: "5px 0",
                          }}
                        >
                          <span> Page: </span>
                          <b>1</b> of <b>1</b>
                        </div>
                      </div>
                    </div>
                  </footer>
                </div>
              </section>
              <section
                style={{
                  background: "#fff",
                  border: isPrinting ? "none" : "",
                }}
                className={
                  isPrinting
                    ? "form__container page__section landscape mt_25"
                    : "form__container  page__section landscape mt_25"
                }
              >
                <div className="container-chart">
                  {/* Header */}
                  <header className="section__header">
                    <div
                      style={{ textDecoration: "none" }}
                      className="header__company"
                    >
                      Rocky Mountain Proficiency Testing - A Division of Rocky
                      Mountain Reference Materials
                    </div>
                  </header>

                  {/* Content with Chart */}
                  <div className="chart__container bordered-chart">
                    <AmendedChart ref={amendedComponentRef} />
                  </div>

                  {/* Footer */}
                  <footer className="section__footer">
                    <div className="footer__info">
                      RMPT 193A - Approved: Daniel Geist - Issue Date:
                      09/01/2017 - Issue #: 2 Page: 2 of 2
                    </div>
                  </footer>
                </div>
              </section>
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
};

export default SampleClosedChart;
